import React from 'react';
import {
    Bug,
    ShieldCheck,
    BedDouble,
    Rat,
    Droplets,
    SprayCan,
    Building2,
    Home,
    PhoneCall,
    CheckCircle,
    MapPin
} from 'lucide-react';
import CTA from './Cta';

const services = [
    {
        id: 'cockroach-control',
        icon: <Bug size={28} />,
        title: 'Cockroach Control',
        processTitle: 'Process / Treatment Method',
        process: [
            { step: 'Step One', text: 'Gel Application' },
            { step: 'Step Two', text: 'Odorless Spray' }
        ],
        benefits: [
            'Totally proven, Odorless, & non messy treatment',
            'Convenient to the CUSTOMER – the services can be executed without any disturbance to the routine work in the house',
            'Effective and long lasting'
        ]
    },
    {
        id: 'termite-control',
        icon: <ShieldCheck size={28} />,
        title: 'Termite Control',
        processTitle: 'Process / Treatment Method',
        process: [
            { text: 'Drill-Fill-Seal Method' }
        ],
        benefits: [
            'Comprehensive Termite protection plan which help you to protect your valuable wood works.',
            'Highly effective, new designed treatment module, convenient and totally hassle free treatment module.'
        ]
    },
    {
        id: 'bed-bug-control',
        icon: <BedDouble size={28} />,
        title: 'Bed Bug Control',
        processTitle: 'Process / Treatment Method',
        process: [
            { text: 'Odorless Spray Treatment' }
        ],
        benefits: [
            'Prevents Bed Bug bites and ensure a peaceful night sleep.',
            'Stops itching and inflammation caused by Bed Bugs.',
            'Maintains hygiene and saves embarrassment with effective bed bugs treatment'
        ]
    },
    {
        id: 'rodent-control',
        icon: <Rat size={28} />,
        title: 'Rodent Control',
        description: 'The IPM approach is especially important in rodent control and involves integrating following...',
        processTitle: 'Process / Treatment Method',
        process: [
            { text: 'Rodent Inspection' },
            { text: 'Sanitation' },
            { text: 'Rodent proofing (exclusion)' },
            { text: 'Population reduction' },
            { text: 'Use Trapping (Glue traps and Snap traps)' },
            { text: 'Use of Rodenticides' }
        ],
        benefits: [
            'An Absolutely new and highly effective treatment used in all developing countries for rodent control',
            'It is designed keeping human safety in mind'
        ],
        note: 'We adopt a treatment regimen depending on the type of premise/outlet, for instance, granules cannot be used where food items are stored as on kitchens'
    },
    {
        id: 'mosquito-control',
        icon: <Droplets size={28} />,
        title: 'Mosquito Control',
        processTitle: 'Service Steps',
        process: [
            { text: 'Larvicide Treatment' },
            { text: 'Indoor Residual Spray (IRS)' },
            { text: 'Fogging' }
        ]
    },
    {
        id: 'general-pest-control',
        icon: <SprayCan size={28} />,
        title: 'General Pest Control'
    },
    {
        id: 'commercial-pest-control',
        icon: <Building2 size={28} />,
        title: 'Commercial Pest Control'
    },
    {
        id: 'residential-pest-control',
        icon: <Home size={28} />,
        title: 'Residential Pest Control'
    }
];

const serviceAreas = ['Mumbai', 'Thane', 'Navi Mumbai', 'Palghar'];

const AllServices = () => {
    return (
        <div className="all-services-page">
            <section className="all-services-hero">
                <h1>Our Services</h1>
                <p>
                    Professional pest management for residential and commercial premises.
                    Service Areas: Mumbai / Thane / Navi Mumbai / Palghar
                </p>
            </section>

            <div className="all-services-list">
                {services.map((service) => (
                    <article className="all-service-block" id={service.id} key={service.id}>
                        <div className="all-service-block-header">
                            <div className="all-service-block-icon">{service.icon}</div>
                            <h2>{service.title}</h2>
                        </div>

                        {service.description && (
                            <div className="all-service-section">
                                <h3>Service Description</h3>
                                <p>{service.description}</p>
                            </div>
                        )}

                        {service.process && (
                            <div className="all-service-section">
                                <h3>{service.processTitle}</h3>
                                <ol className="all-service-process">
                                    {service.process.map((item) => (
                                        <li key={item.step || item.text}>
                                            {item.step && <strong>{item.step}: </strong>}
                                            {item.text}
                                        </li>
                                    ))}
                                </ol>
                            </div>
                        )}

                        {service.benefits && (
                            <div className="all-service-section">
                                <h3>Benefits</h3>
                                <ul className="all-service-benefits">
                                    {service.benefits.map((benefit) => (
                                        <li key={benefit}>
                                            <CheckCircle size={18} />
                                            <span>{benefit}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {service.note && (
                            <p className="all-service-note">{service.note}</p>
                        )}

                        <button
                            className="all-service-call"
                            onClick={() => (window.location.href = 'tel:8530352444')}
                        >
                            <PhoneCall size={16} />
                            Call Now
                        </button>
                    </article>
                ))}
            </div>

            <section className="all-services-areas">
                <h2>
                    <MapPin size={22} />
                    Service Areas
                </h2>
                <ul>
                    {serviceAreas.map((area) => (
                        <li key={area}>{area}</li>
                    ))}
                </ul>
            </section>

            <CTA />
        </div>
    );
};

export default AllServices;
